export class UserDoc{
	docType       : string;
	docSerialNo   : string;
	docNameSlug  ?: string;
	docSlug       : string;
	docFrontUrl   : string;
	docRearUrl    : string;
	docIssueDate  : string;
	docExpiryDate : string ;
}